
import './App.css';
import Header from './components/Header/Header.js';
import Home from './pages/Home/Home';
function App() {
  return (
    <div className="App">
        <Header />
      <Home/> 
    </div>
  );
}

export default App;
